import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import * as authSelectors from '@auth/store/auth.selectors';

import { environment } from '@environment';

@Injectable()
export class AuthService {
  // relogin dialog
  public reloginDialog$ = new BehaviorSubject<boolean>(false);
  public reloginShowing = new BehaviorSubject('grid');
  public changeCustomerOrFacilityPending$ = new BehaviorSubject(false);

  // change customer dialog
  public changeCustomerDialog$ = new BehaviorSubject<boolean>(false);
  public changeCustomerDismissDialog = new BehaviorSubject(false);
  public changeCustomerShowing = new BehaviorSubject('grid');
  public changeCustomerFilterMode = new BehaviorSubject(false);
  public customerDialogFilter$ = new BehaviorSubject<any>(null);
  public selectedCustomerRow$ = new BehaviorSubject(null);

  // change facility dialog
  public changeFacilityDialog$ = new BehaviorSubject<boolean>(false);
  public changeFacilityDismissDialog = new BehaviorSubject(false);
  public changeFacilityShowing = new BehaviorSubject('grid');
  public changeFacilityFilterMode = new BehaviorSubject(false);
  public facilityDialogFilter$ = new BehaviorSubject<any>(null);
  public selectedFacilityRow$ = new BehaviorSubject(null);

  public permissions = new BehaviorSubject<any>(null);

  user$ = this.store.select(authSelectors.selectUser);

  permissions$ = this.store.select(authSelectors.selectAuthPermissions);

  authData$ = this.store.select(authSelectors.selectAuthData);

  hasPassThru$ = this.store.select(authSelectors.selectHasPassThru);

  reloginStatus$ = this.store.select(authSelectors.selectReloginStatus);

  changedModule$ = this.store.select(authSelectors.selectHasModuleChanged);

  apiVersion$ = this.store.select(authSelectors.selectApiVersion);

  constructor(private http: HttpClient, private store: Store) {
    this.permissions$.subscribe((p) => {
      this.permissions.next(p);
    });
  }

  login(username: string, password: string) {
    return this.http.post(environment.loginEndpoint, { username, password }, { withCredentials: true });
  }

  logout(): void {
    this.http.post(environment.logoutEndpoint, {}, { withCredentials: true }).pipe(take(1)).subscribe();
  }

  changeCustomer(custid: string) {
    this.changeCustomerOrFacilityPending$.next(true);

    return this.http.put(environment.changeCustomerEndpoint, { custid }, { withCredentials: true }).pipe(
      tap(() => {
        this.changeCustomerOrFacilityPending$.next(false);
      })
    );
  }

  changeFacility(facility: string) {
    this.changeCustomerOrFacilityPending$.next(true);

    return this.http.put(environment.changeFacilityEndpoint, { facility }, { withCredentials: true }).pipe(
      tap(() => {
        this.changeCustomerOrFacilityPending$.next(false);
      })
    );
  }

  hasPermission(perm: string) {
    const permission = this.permissions.value;

    const allow = permission?.allow;
    const deny = permission?.deny;
    const facility = permission?.facility;

    return (
      (!deny?.ALLFAC?.includes(perm) && allow?.ALLFAC?.includes(perm)) ||
      (!deny[facility]?.includes(perm) && allow[facility]?.includes(perm))
    );
  }
}
